var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PlayMode, usePreviewLoop } from 'hx-din-test-2';
import { CirclesSelect } from 'hx-ui';
import { useCustomValidationField } from 'hx-util';
import { BiUserVoice } from 'react-icons/bi';
import { StepLayout } from './step-layout.component';
import { pageImages } from '@/pages/images';
import { LogoAndHeading } from './logo-and-heading.component';
import { NavigationButton, NavigationButtonsContainer, } from './navigation-button.component';
import { useNavigate } from 'react-router-dom';
export var HeadphoneCheck = function () {
    var validate = useCustomValidationField({
        validationFieldName: 'headphone-check-valid',
        fieldName: 'headphone-check',
        validationFunction: function (value) {
            return value !== 'both' && value !== 'right';
        },
    }).validate;
    usePreviewLoop({
        autoPlay: true,
        config: {
            playMode: PlayMode.MonoauralLeft,
        },
    });
    var navigate = useNavigate();
    return (_jsx(StepLayout, { image: pageImages.guyListeningWithHeadphones, heading: _jsx(LogoAndHeading, { headingText: 'In which ear do you hear the sound?', className: "text-lg md:text-2xl", image: {
                height: 110,
                width: 118,
            } }), progress: {
            phase: 0,
            step: 5,
        }, content: _jsx("div", __assign({ className: "grid gap-4 px-6 place-items-center" }, { children: _jsx("div", __assign({ className: "grid place-items center" }, { children: _jsx(CirclesSelect, { controllerProps: {
                        name: 'headphone-check',
                        rules: {
                            required: 'Please select an option before continuing',
                            validate: validate,
                        },
                    }, itemStyles: {
                        height: '5rem',
                        width: '5rem',
                        boxShadow: 'none',
                    }, options: [
                        {
                            value: 'left',
                            label: 'Left',
                            icon: _jsx(BiUserVoice, { style: { transform: 'scale(-1, 1)' } }),
                        },
                        {
                            value: 'both',
                            label: 'Both',
                            icon: _jsx(BothIcon, {}),
                            onClick: function () { return navigate('/headphone-information'); },
                        },
                        {
                            value: 'right',
                            label: 'Right',
                            icon: _jsx(BiUserVoice, {}),
                            onClick: function () { return navigate('/headphone-information'); },
                        },
                    ] }) })) })), nav: _jsx(NavigationButtonsContainer, { children: _jsx(NavigationButton, { type: "back", variant: "outlined", label: "Previous" }) }) }));
};
var BothIcon = function () {
    return (_jsxs("div", __assign({ style: {
            position: 'relative',
            height: '2rem',
            width: '2rem',
        } }, { children: [_jsx(BiUserVoice, { style: {
                    transform: 'scale(-1, 1)',
                    position: 'absolute',
                    left: '-0.313rem',
                } }), _jsx(BiUserVoice, { style: {
                    position: 'absolute',
                    left: '0.375rem',
                } })] })));
};
